<template>
    <div>
        <b-form @submit="createGame($event)">
            <div class="row" ref="formTop">
            <b-card class="col-12 col-md-12 col-lg-6">
                <b-card-title title-tag="h5" title="Create Game"></b-card-title>
                <b-card-body class="px-0">
                    <b-form-group label="Game Name" label-for="game_name">
                        <b-form-input id="game_name" v-model="game.title"></b-form-input>
                    </b-form-group>
                    <b-form-group label="Game Site" label-for="game_site">
                        <b-form-select id="game_site" v-model="game.site_id" :options="siteOptions" required></b-form-select>
                    </b-form-group>
                    <b-form-group label="Slots" label-for="game_slots">
                        <b-form-input id="game_slots" type="number" v-model="game.slots" required></b-form-input>
                    </b-form-group>
                <b-form-group label="Private Hire" label-for="game_private_hire">
                    <b-form-checkbox id="game_private_hire" v-model="game.private_hire" size="lg" switch></b-form-checkbox>
                </b-form-group>
                </b-card-body>
            </b-card>
            <b-card class="col-12 col-md-12 col-lg-6">
                <b-card-title title-tag="h5" title="Timings"></b-card-title>
                <b-card-body class="px-0">
                <b-form-group label="Start Date / Time" label-for="game_start_date">
                    <b-form-datepicker id="game_start_date" :min="minStartDate" v-model="start.date" required></b-form-datepicker>
                    <b-input-group>
                        <template #prepend>
                            <b-input-group-text><i class="fal fa-fw fa-clock"></i></b-input-group-text>
                        </template>
                        <b-form-select v-model="start.time" :options="startTimeOptions"></b-form-select>
                    </b-input-group>
                </b-form-group>
                <b-form-group label="End Date / Time" label-for="game_end_date">
                    <b-form-datepicker id="game_end_date" :min="minEndDate" v-model="end.date" required></b-form-datepicker>
                    <b-input-group>
                        <template #prepend>
                            <b-input-group-text><i class="fal fa-fw fa-clock"></i></b-input-group-text>
                        </template>
                        <b-form-select v-model="end.time" :options="endTimeOptions"></b-form-select>
                    </b-input-group>
                </b-form-group>
                </b-card-body>
            </b-card>
            <b-card class="col-12">
                <b-card-title title-tag="h5" title="Pricing"></b-card-title>
                <b-card-body class="px-0">
                <b-form-group label="Price" label-for="game_price">
                    <b-form-input id="game_price" type="number" step=".01" v-model.number="game.price" required></b-form-input>
                </b-form-group>
                <b-form-group label="Marshal Price" label-for="game_marshal_price">
                    <b-form-input id="game_marshal_price" type="number" step=".01" v-model.number="game.marshal_price" required></b-form-input>
                </b-form-group>
                <div class="row">
                    <div class="col-sm-12 col-md-6 col-lg-2">
                        <b-form-group label-align="left" label="Marshal Booking Discount" label-for="game_marshal_booking_discount">
                            <b-form-checkbox id="game_marshal_booking_discount" v-model="game.marshal_booking_discount" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-2">
                        <b-form-group label-align="left" label="Discount Accept" label-for="game_discount_accept">
                            <b-form-checkbox id="game_discount_accept" v-model="game.discount_accept" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-2">
                        <b-form-group label-align="left" label="Free Game Pass Accept" label-for="game_free_game_pass_accept">
                            <b-form-checkbox id="game_free_game_pass_accept" v-model="game.free_game_pass_accept" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                    </div>
                    <div class="col-sm-12 col-md-6 col-lg-2">
                        <b-form-group label-align="left" label="Bookable" label-for="game_bookable">
                            <b-form-checkbox id="game_bookable" v-model="game.bookable" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-2">
                        <b-form-group label-align="left" label="Is Open" label-for="game_is_open">
                            <b-form-checkbox id="game_is_open" v-model="game.is_open" size="lg" switch></b-form-checkbox>
                        </b-form-group>
                    </div> -->
                </div>

                <div class="row">
                    <div class="col-12">
                        <b-form-group label="Game Notes" label-for="game_note">
                            <b-form-textarea id="game_note" v-model="gameNote.message" rows="6"></b-form-textarea>
                        </b-form-group>
                    </div>
                </div>

                <b-button type="submit" variant="primary" :disabled="loading">Create Game</b-button>
                </b-card-body>
            </b-card>
            </div>
        </b-form>
    </div>
</template>
<script>
import moment from 'moment-timezone';
export default {
    props: {},
    data() {
        return {
            loading: false,
            start: {
                date: null,
                time: null,
            },
            end: {
                date: null,
                time: null,
            },
            game: {
                title: "",
                site_id: "",
                slots: 0,
                private_hire: 0,
                start_time: this.startDateTime,
                end_time: this.endDateTime,
                price: 0,
                marshal_price: 0,
                marshal_booking_discount: false,
                discount_accept: false,
                free_game_pass_accept: false,
                bookable: false,
                is_open: true,
            },
            gameNote: {
                note: null,
            },
            moment: window.moment,
            sites: Sites,
        }
    },
    computed: {
        siteOptions() {
            return this.sites.map(site => {
                return { value: site.id, text: site.title };
            });
        },
        startDateTime() {
            if (!this.start.date || !this.start.time) {
                return null;
            }
            // return this.start.date + " " + this.start.time;
            return moment.tz(`${this.start.date} ${this.start.time}`, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().format();
        },
        endDateTime() {
            return moment.tz(`${this.end.date} ${this.end.time}`, 'YYYY-MM-DD HH:mm', moment.tz.guess()).utc().format();
        },
        minStartDate() {
            return new moment().format("YYYY-MM-DD");
        },
        minEndDate() {
            if (!this.start.date) {
                return null;
            }

            return this.start.date;
        },
        minEndTime() {
            if (!this.start.time) {
                return null;
            }

            return this.start.time;
        },
        startTimeOptions() {
            let times = [];
            for (let hour = 0; hour < 24; hour++) {
                for (let minute = 0; minute < 60; minute += 15) {
                    let timeString = hour.toString().padStart(2, "0") + ":" + minute.toString().padStart(2, "0");
                    times.push({value: timeString, text: timeString});
                }
            }

            return times;
        },
        endTimeOptions() {
            let options = [];

            if (! this.start.time) {
                return this.startTimeOptions;
            }

            const [startHour, startMinute] = this.start.time.split(':').map(Number);
            let startTime = new Date();
            startTime.setHours(startHour, startMinute, 0, 0);
            // Start from the next possible 15-minute increment after the start time
            startTime.setMinutes(startTime.getMinutes() + 15);
            for (let hour = startTime.getHours(); hour < 24; hour++) {
                for (let minute = (hour === startTime.getHours() ? Math.ceil(startTime.getMinutes() / 15) * 15 : 0); minute < 60; minute += 15) {
                    let timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                    options.push({value: timeString, text: timeString});
                }
            }
            return options;
        },
    },
    methods: {
        createGame(event) {
            event.preventDefault();
            this.loading = true;
            this.game.start_time = this.startDateTime;
            this.game.end_time = this.endDateTime;
            this.game.price = this.game.price * 100;
            this.game.marshal_price = this.game.marshal_price * 100;
            axios.post(this.$routes.route("game.store"), this.game)
                .then((result) => {
                    this.game.price = this.game.price / 100;
                    this.game.marshal_price = this.game.marshal_price / 100;
                    if (this.gameNote.message) {
                        axios.post(this.$routes.route('note.storeForGame', { game: result.data.id}), this.gameNote)
                            .then((response) => {
                                this.loading = false;
                                window.location.href = this.$routes.route("game.show", { game: result.data.id });
                            })
                            .catch((err) => {
                                console.error(err);
                            });
                    } else {
                        this.loading = false;
                        // this.$router.push({ name: "game.show", params: { game: result.data.id } });
                        window.location.href = this.$routes.route("game.show", { game: result.data.id });
                    }
                })
                .catch((err) => {
                    console.error(err);
                    this.loading = false;
                });
        }
    },
    mounted() {}
}
</script>